import { OrderTypes } from "@dana/Handlers/ProductAvailabilityHandler";
import {
    getCartLine,
    RemoveCartLineApiParameter,
    removeCartLineWithResult as removeCartLineApi,
} from "@dana/Overrides/Services/CartService";
import loadAnnualReturnsCart from "@dana/Store/Data/AnnualReturnsCart/AnnualReturnsCartHandler";
import loadEmergencyCart from "@dana/Store/Data/EmergencyCart/EmergencyCartHandler";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { sendRemoveFromCartEvent } from "@insite/client-framework/OdpEvents/UpdateCartEvents";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

type Parameter = {
    cartLineId: string;
    isEmergencyOrder?: boolean;
    isAnnualReturnsOrder?: boolean;
};

type Props = {
    apiParameter: RemoveCartLineApiParameter;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginRemoveCartLine: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
    props.dispatch({
        type: "Pages/Cart/BeginRemoveCartLine",
        cartLineId: props.parameter.cartLineId,
    });
};

export const SendRemoveFromCartEvent: HandlerType = async props => {

    const orderType = getCookie('modalOrderType');
    let additionalQueryStringParameters = {};
    if (props.parameter.isEmergencyOrder === undefined) {
        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.EMERGENCY) {
            additionalQueryStringParameters = {
                "IsEmergencyOrder": true
            }
        }
    } else if (props.parameter.isEmergencyOrder) {
        additionalQueryStringParameters = {
            "IsEmergencyOrder": true
        }
    }

    if (props.parameter.isAnnualReturnsOrder === undefined) {
        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.ANNUALRETURNS) {
            additionalQueryStringParameters = {
                "IsAnnualReturnsOrder": true
            }
        }
    } else if (props.parameter.isAnnualReturnsOrder) {
        additionalQueryStringParameters = {
            "IsAnnualReturnsOrder": true
        }
    }

    const cartLineModel = await getCartLine({
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineId: props.parameter.cartLineId,
        expand: ["hiddenproducts"],
        additionalQueryStringParameters
    });

    sendRemoveFromCartEvent(
        { productId: cartLineModel.productId!, qtyOrdered: cartLineModel.qtyOrdered! },
        props.getState(),
    );
};

export const PopulateApiParameter: HandlerType = props => {

    props.apiParameter = {
        cartLineId: props.parameter.cartLineId,
        cartId: API_URL_CURRENT_FRAGMENT,
    };

    if (props.parameter.isEmergencyOrder === undefined) {
        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.EMERGENCY) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsEmergencyOrder": true
            }
        }
    } else if (props.parameter.isEmergencyOrder !== undefined && props.parameter.isEmergencyOrder) {
        props.apiParameter.additionalQueryStringParameters = {
            "IsEmergencyOrder": true
        }
    }

    if (props.parameter.isAnnualReturnsOrder === undefined) {
        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.ANNUALRETURNS) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsAnnualReturnsOrder": true
            }
        }
    } else if (props.parameter.isAnnualReturnsOrder !== undefined && props.parameter.isAnnualReturnsOrder) {
        props.apiParameter.additionalQueryStringParameters = {
            "IsAnnualReturnsOrder": true
        }
    }
};

export const RemoveCartLine: HandlerType = async props => {
    await removeCartLineApi(props.apiParameter);
};

export const LoadCart: HandlerType = props => {
    if (props.apiParameter?.additionalQueryStringParameters?.IsEmergencyOrder && props.apiParameter?.additionalQueryStringParameters?.IsEmergencyOrder === true) {
        props.dispatch(loadEmergencyCart({
            cartId: API_URL_CURRENT_FRAGMENT
        }));
    }
    else if (props.apiParameter?.additionalQueryStringParameters?.IsAnnualReturnsOrder && props.apiParameter?.additionalQueryStringParameters?.IsAnnualReturnsOrder === true) {
        props.dispatch(loadAnnualReturnsCart({
            cartId: API_URL_CURRENT_FRAGMENT
        }));
    } 
    else {
        props.dispatch(loadCurrentCart({ getPromotions: true }));
    }
};

/** @deprecated Not needed anymore */
export const LoadPromotions: HandlerType = () => { };

export const DispatchCompleteRemoveCartLine: HandlerType = props => {
    props.dispatch({
        type: "Pages/Cart/CompleteRemoveCartLine",
        cartLineId: props.parameter.cartLineId,
    });
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
    props.dispatch({
        type: "Data/OrderApprovals/Reset",
    });
};

export const chain = [
    DispatchBeginRemoveCartLine,
    SendRemoveFromCartEvent,
    PopulateApiParameter,
    RemoveCartLine,
    LoadCart,
    LoadPromotions,
    DispatchCompleteRemoveCartLine,
];

const removeCartLine = createHandlerChainRunner(chain, "RemoveCartLine");
export default removeCartLine;
